<template>
  <div class="control" v-tooltip.left="'Take a snapshot'" @click="takeScreenshot">
    <img src="../../assets/icon_snapshot.svg" style="height: 23px;">
  </div>
</template>

<script>
  export default {
    name: 'TakeScreenshot',
    props: {
      currentMediaElements: {
        type: Array
      },
      callSid: {
        type: String
      },
      mode: {
        type: String
      }
    },
    methods: {
      takeScreenshot()  {
        if(this.mode === 'normal') {
          this.takeVideoScreenshot()
        } else if(this.mode === 'timeslice') {
          this.$emit('takeTimesliceScreenshot')
        }
      },

      takeVideoScreenshot() {
        let video = this.currentMediaElements.find(el => {
          return  el instanceof HTMLVideoElement
        });

        var canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
        var dataURI = canvas.toDataURL('image/jpeg')

        this.$store.dispatch('screenshots/uploadScreenshot', {image: dataURI, callSid: this.callSid})
      }
    }
  }
</script>

<style scoped>

</style>
